import React, { useEffect } from "react";
import steamImg from "../assets/steam.png";
import steamLongImg from "../assets/steamLong.png";
import "../css/SteamLoginButton.css";

const SteamLoginButton = ({ overlay = false, long = false, big = false }) => {
  useEffect(() => {
    // Listen for messages from popup
    const handleMessage = (event) => {
      // Verify the origin - should be from localhost:4000 (backend)
      const backendOrigin = new URL(process.env.REACT_APP_BACKEND_URL).origin;
      if (event.origin !== backendOrigin) {
        return;
      }

      if (event.data.type === "STEAM_LOGIN_SUCCESS") {
        // Reload the page to update auth state
        window.location.reload();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const handleSteamLogin = () => {
    // Open Steam auth in popup window
    const width = 600;
    const height = 700;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    const popup = window.open(
      `${process.env.REACT_APP_BACKEND_URL}/users/auth/steam`,
      "Steam Login",
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
    );

    // Check if popup was blocked
    if (!popup || popup.closed || typeof popup.closed === "undefined") {
      alert("Popup was blocked. Please allow popups for this site.");
    }
  };

  return (
    <>
      {overlay ? (
        <div className="absolute-overlay">
          <img
            onClick={handleSteamLogin}
            className="steam-button"
            src={long ? steamLongImg : steamImg}
            alt="Sign in with Steam"
          ></img>
        </div>
      ) : (
        <img
          onClick={handleSteamLogin}
          className="steam-button"
          src={long ? steamLongImg : steamImg}
          alt="Sign in with Steam"
        ></img>
      )}
    </>
  );
};

export default SteamLoginButton;
